// Ce que chaque forfait débloque, en langage client — source unique pour la
// landing (Landing.jsx), l'écran Mon abonnement (MonAbonnement.jsx) et
// l'assistant de la landing (server/routes/chatbot.js, qui lit le même JSON).
//
// Le contenu est dans planFeatures.json (lisible par le serveur CommonJS).
// Doit refléter EXACTEMENT server/config/plans.js (modules gatés par
// requireModule → tenant_modules) et le socle non gaté. Ne rien promettre
// qui n'existe pas dans le code. Vérifié le 01/10/2026 :
//  - Essentiel : routes non gatées (factures/devis, relances, compta, TVA,
//    FEC, trésorerie/import bancaire, immobilisations, accès expert-comptable).
//    IA réellement disponible : lecture des factures PDF (OCR fournisseurs
//    et ventes). Le chat IA (/api/ai) exige le module analytique → Business ;
//    la suggestion de compte repose sur des règles apprises, pas sur l'IA.
//  - Quotas IA : server/services/aiUsage.js (QUOTAS).
//  - Conformité (veille, DEB, EUR.1) retirée le 02/10/2026 : module en préparation.
import PLAN_FEATURES_JSON from "./planFeatures.json";

export const PLAN_FEATURES = PLAN_FEATURES_JSON;
